import React, { useEffect, useState } from "react";
import logo from "../../images/almoune-logo-1.jpg";
import member1 from "../../images/01.jpg";
import member3 from "../../images/03.jpg";
import idea from "../../images/idea.gif";
import team from "../../images/team.gif";
import award from "../../images/award.gif";
import { Link } from "react-router-dom";
import { MagnifyingGlass } from "react-loader-spinner";
import { Slide, Zoom } from "react-awesome-reveal";
import ScrollToTop from "../ScrollToTop";

const AboutUs = () => {
  const [loaderStatus, setLoaderStatus] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoaderStatus(false);
    }, 1500);
  }, []);

  return (
    <div>
      <div>
        {loaderStatus ? (
          <div className="loader-container">
            <MagnifyingGlass
              visible={true}
              height="100"
              width="100"
              ariaLabel="magnifying-glass-loading"
              wrapperStyle={{}}
              wrapperclassName="magnifying-glass-wrapper"
              glassColor="#c0efff"
              color="#0aad0a"
            />
          </div>
        ) : (
          <>
            <ScrollToTop />
            <section className="position-relative pt-5">
              <div className="container position-relative zindex-5 pt-5">
                <div className="row">
                  <div className="col-lg-6">
                    <Slide direction="down">
                      <h1 className="pb-2 pb-md-3">A propos d'Almoune</h1>
                      <h3 className="pb-2 pb-md-3">L'epicerie libanaise en ligne pour vos courses orientales au quotidien</h3>
                      <p className="fs-xl pb-4 mb-1 mb-md-2 mb-lg-3" style={{ maxWidth: 526 }}>
                        Almoune propose une selection de produits libanais et orientaux pour retrouver les saveurs du quotidien:
                        epicerie salee, boissons, douceurs, condiments, cafe, produits frais et incontournables de la cuisine levantine.
                      </p>
                      <p className="pb-3 mb-0" style={{ maxWidth: 560 }}>
                        La boutique met en avant des marques aimees, des produits traditionnels et des promotions regulieres,
                        avec une navigation simple pour commander rapidement depuis chez soi.
                      </p>
                      <img src={logo} className="d-dark-mode-none rounded-3" width={260} alt="Logo Almoune" />
                      <div className="row row-cols-3 pt-4 pt-md-5 mt-2 mt-xl-4">
                        <div className="col"><h3 className="h3 mb-2">2 000+</h3><p className="mb-0"><strong>references</strong> en boutique</p></div>
                        <div className="col"><h3 className="h3 mb-2">49 EUR</h3><p className="mb-0"><strong>livraison offerte</strong> des ce montant</p></div>
                        <div className="col"><h3 className="h3 mb-2">09 81 39 14 33</h3><p className="mb-0"><strong>service client</strong> a votre ecoute</p></div>
                      </div>
                    </Slide>
                  </div>
                  <div className="col-lg-6 mt-xl-3 pt-5 pt-lg-4">
                    <div className="row row-cols-2 gx-3 gx-lg-4">
                      <div className="col pt-lg-5 mt-lg-1">
                        <Zoom><img src={member1} className="d-block rounded-3 mb-3 mb-lg-4" alt="almoune" /></Zoom>
                      </div>
                      <div className="col">
                        <Zoom><img src={member3} className="d-block rounded-3 mb-3 mb-lg-4" alt="epicerie" /></Zoom>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="container mt-8 mb-5 pt-lg-5" id="benefits">
              <div className="row">
                <div className="col-md-4 text-center">
                  <Zoom><img src={idea} width="100" alt="selection" className="d-block mb-4 mx-auto" /></Zoom>
                  <Slide direction="up">
                    <h4 className="mb-2 pb-1">Selection libanaise</h4>
                    <p className="mx-auto" style={{ maxWidth: "336px" }}>
                      Des indispensables du Liban et de l'Orient, choisis pour une boutique utile au quotidien.
                    </p>
                  </Slide>
                </div>
                <div className="col-md-4 text-center">
                  <Zoom><img src={award} width="100" alt="qualite" className="d-block mb-4 mx-auto" /></Zoom>
                  <Slide direction="up">
                    <h4 className="mb-2 pb-1">Promotions et marques connues</h4>
                    <p className="mx-auto" style={{ maxWidth: "336px" }}>
                      Une mise en avant des meilleures ventes, des offres speciales et des marques recherchees par les clients.
                    </p>
                  </Slide>
                </div>
                <div className="col-md-4 text-center">
                  <Zoom><img src={team} width="100" alt="service" className="d-block mb-4 mx-auto" /></Zoom>
                  <Slide direction="up">
                    <h4 className="mb-2 pb-1">Commande simple et livraison claire</h4>
                    <p className="mx-auto" style={{ maxWidth: "336px" }}>
                      Un parcours de commande plus lisible, des informations utiles et un contact direct quand vous en avez besoin.
                    </p>
                  </Slide>
                </div>
              </div>
            </section>

            <section className="container pb-5 mb-2 mt-8 mb-md-4 mb-lg-5">
              <div className="position-relative bg-secondaryy rounded-3 py-5 mb-2">
                <div className="row pb-2 py-md-3 py-lg-5 px-4 px-lg-0 position-relative zindex-3">
                  <div className="col-xl-3 col-lg-4 col-md-5 offset-lg-1">
                    <Slide direction="down" delay={0.5}>
                      <p className="lead mb-2 mb-md-3">Une boutique pensee pour vos envies</p>
                      <h2 className="h1 pb-3">Pourquoi choisir Almoune ?</h2>
                    </Slide>
                  </div>
                  <div className="col-lg-6 col-md-7 offset-xl-1 zindex-3">
                    <div className="row">
                      <div className="col-12 mb-4">
                        <h5 className="mb-2">Des produits familiers et authentiques</h5>
                        <p className="mb-0">
                          Almoune rassemble des references appreciees dans les foyers:
                          pains, conserves, cafes, douceurs, boissons, aides culinaires et specialites orientales.
                        </p>
                      </div>
                      <div className="col-12 mb-4">
                        <h5 className="mb-2">Une boutique pratique a parcourir</h5>
                        <p className="mb-0">
                          Les rayons, promotions et produits phares sont faciles a retrouver pour faire ses courses plus rapidement.
                        </p>
                      </div>
                      <div className="col-12">
                        <h5 className="mb-2">Un lien direct avec le client</h5>
                        <p className="mb-0">
                          Livraison, telephone, informations utiles et accompagnement:
                          la boutique garde un contact simple et rassurant avec ses clients.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="container pb-5 mb-4">
              <div className="text-center">
                <h2 className="h1 mb-3">Decouvrir la boutique Almoune</h2>
                <p className="mb-4">
                  Retrouvez les rayons, les promotions, les produits populaires et les informations client directement depuis la boutique en ligne.
                </p>
                <Link to="/Shop" className="btn btn-outline-primary btn-lg">Decouvrir la boutique</Link>
              </div>
            </section>
          </>
        )}
      </div>
    </div>
  );
};

export default AboutUs;
